import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import styled from 'styled-components';

import { IMAGES_ACTIONS } from '../../store/actions';
import { Status } from '../../store/models/europrisme';
import { connect } from '../../utils/redux';

const ResourceImageContainer = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: white;
`;

const ImageB64 = ({ path, style, loader, images, fetchImageB64 }) => {
  const image = images[path] || {};

  useEffect(() => {
    if (!image.B64 && !image.status !== Status.IDLE) {
      fetchImageB64({ sLocalPath: path });
    }
  }, [path]);

  if (image.B64) {
    return <ResourceImageContainer src={image.B64} style={style} />;
  }

  return loader;
};

ImageB64.propTypes = {
  path: PropTypes.string.isRequired,
  style: PropTypes.objectOf(PropTypes.any),
  loader: PropTypes.node,
  images: PropTypes.objectOf(PropTypes.any).isRequired,
  fetchResourceB64: PropTypes.func.isRequired,
};

ImageB64.defaultProps = {
  style: {},
  loader: null,
};

export default connect(
  state => ({
    ...state.images,
  }),
  { ...IMAGES_ACTIONS },
)(ImageB64);
